import { Component, OnDestroy, OnInit } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { getBrokersList, getFareShitDaysAsObject, getShiftDays } from 'src/app/utils/utils.common';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DynamicFareServiceService } from '../dynamic-fare-service/dynamic-fare-service.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as _ from 'underscore';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { C } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-dynamic-fare-list',
  templateUrl: './dynamic-fare-list.component.html',
  styleUrls: ['./dynamic-fare-list.component.css']
})
export class DynamicFareListComponent implements OnInit, OnDestroy {
  dynamicfaresList = [];
  search;
  user;
  selectedCorporate = '';
  corporateList = [];
  filteredFaresList = [];
  status = "active";
  daysList = getFareShitDaysAsObject();
  preCooperates = {};
  filteredCorporates = [];
  filteredLevelOfService = [];
  selectedLOS = [];
  filteredSpaceType = [];
  selectedSpaceType = [];
  fundingSources:any;
  
  constructor(
    private corporateService : CorporateService,
    public authService: AuthService,
    private dynamicFareService: DynamicFareServiceService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.getUser();
    // this.getDynamicFareList();
    this.getCorporate();
    
  }

  onCorporateChange() {
    this.filteredFaresList = []
    this.getDynamicFareList();

    this.filteredFaresList = this.dynamicfaresList.filter(fare => {

      // let isCooperateExists = true;
      let isLosExists = true;
      let isSpaceTypeExists = true;

      // if (fare.cooperate && this.selectedCorporate && this.selectedCorporate.length) {
      //   const isExist = this.selectedCorporate.find(sId => sId === fare.cooperate._id);

      //     if (isExist) {
      //       isCooperateExists = true;
      //     } else {
      //       isCooperateExists = false;
      //   }
      // }
      if(fare.los && this.selectedLOS && this.selectedLOS.length){
        if (fare.los) {
          isLosExists = this.selectedLOS.includes(fare.los._id);
        } else {
          isLosExists = false;
        }
      }
      if (fare.spaceType && this.selectedSpaceType && this.selectedSpaceType.length){
        if (fare.spaceType) {
          isSpaceTypeExists = this.selectedSpaceType.includes(fare.spaceType._id);
        } else {
          isSpaceTypeExists = false;
        }
      }
      if (isLosExists && isSpaceTypeExists) {
        return true;
      } else {
        return false;
      }
    }
    );

  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data;
        }
      });
  }

  getDynamicFareList() {
    let queryParams = {
      status: this.status,
      cooperate : this.selectedCorporate
    }
    // this.corporateList = [];
    this.filteredLevelOfService = [];
    this.filteredSpaceType = [];
    // this.selectedCorporate = [];
    this.dynamicFareService
      .getDynamicFareList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dynamicfaresList = data;
          this.filteredFaresList = this.dynamicfaresList; // Initially show all fares
          
          for (let fare of this.dynamicfaresList) {
            // if (fare.cooperate) {
            //   this.corporateList.push(fare.cooperate);
            // }
            if(fare.los){
              this.filteredLevelOfService.push(fare.los)
            }
            if (fare.spaceType) {
              this.filteredSpaceType.push(fare.spaceType)
            }
          }

          // this.corporateList = _.uniq(this.corporateList, '_id').sort();
          this.filteredLevelOfService = _.uniq(this.filteredLevelOfService, '_id').sort();
          this.filteredSpaceType = _.uniq(this.filteredSpaceType, '_id').sort();
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getBroker(broker){
    return getBrokersList[broker]
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data ) {
          this.fundingSources = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  onChangeStatus() {
    this.getDynamicFareList();
  }

  ngOnDestroy(): void {
  }
}
